<template>
  <div class="sub-tab">
    <el-radio-group v-model="localValue" @input="onInputChange">
      <el-radio-button
        v-for="(option, index) in options"
        :key="index"
        :label="option.value"
        :disabled="option.disabled"
        >
       <span> {{ option.label }}</span>
      </el-radio-button>
    </el-radio-group>
  </div>
</template>

<script>
export default {
  name: "subTab",
  props: {
    value: {
      type: [String, Number],
      required: true,
    },
    options: {
      type: Array,
      required: true,
      default: () => [],
    },
    disabledOptions: {
      type: Array,
      default: () => [],
    },
    isIndex: {
      tyoe: Boolean,
      default: false,
    },
  },
  data() {
    return {
      localValue: this.value,
    };
  },
  methods: {
    onInputChange(newValue) {
      this.$emit("input", newValue);
    },
  },
  watch: {
    value(newVal) {
      this.localValue = newVal;
    },
  },
};
</script>

<style scoped lang="scss">
.sub-tab {
  
 
  ::v-deep .el-radio-group {
    padding: 4px;
    background: #f5f5f7;
    border-radius: 4px;
  }

  ::v-deep .el-radio-button__inner {
    border-color: #f5f5f7;
    box-shadow: none;
    font-size: $main-size !important;
    color: $text-6 !important;
    font-weight: normal !important;
    // font-family: 'PingFang SC';
    background-color: rgba(0, 0, 0, 0);
  }

  ::v-deep .el-radio-button__orig-radio:checked + .el-radio-button__inner {
    font-size: $main-size !important;
    color: $text-color !important;
    font-weight: normal !important;
    // font-family: 'PingFang SC';
    background: white;
    border-radius: 4px;
  }
  ::v-deep
    .el-radio-button:focus:not(.is-focus):not(:active):not(.is-disabled) {
    box-shadow: none !important;
  }
}
</style>
